import { Box, HStack } from "@chakra-ui/react";
import Pagination from "./Pagination";
import { DownloadToExcelButton } from "./DownloadToExcelButton";

type TableProps<T extends Record<string, unknown>> = {
  fileName: string;
  items: T[];
  columns: readonly {
    key: string;
    label: string;
    format?: "datetime" | "none" | "currency" | "badge" | "status";
    exportTransform?: (value: T) => string | number;
  }[];
  pagination: {
    tableKey: string;
    cursor: string | undefined;
    nextCursor: string | undefined;
    setCursor: (cursor: string | undefined) => void;
  };
};

type Props<T extends Record<string, unknown>> = {
  tableProps: TableProps<T>;
};

const TableFooter = <T extends Record<string, unknown>>({
  tableProps,
}: Props<T>): JSX.Element => {
  const { pagination, fileName, items, columns } = tableProps;

  return (
    <Box
      display={"flex"}
      flexDirection={"row"}
      justifyContent={"space-between"}
      alignItems={"center"}
      pt={4}
      borderTop="1px solid"
      borderColor="gray.100"
    >
      <HStack gap={4}>
        {pagination && (
          <Pagination
            tableKey={pagination.tableKey}
            itemsCount={items.length}
            cursor={pagination.cursor}
            nextCursor={pagination.nextCursor}
            setCursor={pagination.setCursor}
          />
        )}
        <DownloadToExcelButton
          fileName={fileName}
          items={items}
          tableColumns={columns}
        />
      </HStack>
    </Box>
  );
};

export default TableFooter;
